import { render, staticRenderFns } from "./reports-dashboard.vue?vue&type=template&id=8ea4511a"
import script from "./reports-dashboard.vue?vue&type=script&lang=js"
export * from "./reports-dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports